module.exports = __webpack_public_path__ + "static/goal-front-39f675a59869342af9dbc3843a1491e2.png";